// extracted by mini-css-extract-plugin
export var cartContainer = "_iw-4";
export var gray = "_iw-1";
export var itemContainer = "_iw-2";
export var itemDetails = "_iw-3";
export var strong = "_iw-0";